<template>
  <nav class="navbar fixed-top navbar-expand-lg navbar-light bg-white">
    <div class="logo-container">
      <a style="cursor: pointer" class="navbar-brand" @click="navigate('/')"
        >Ardunic</a
      >
      <span class="logo-p">Build Anything</span>
    </div>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
      @click="toggleMenu"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div
      :class="`collapse ${isOpen ? 'show' : ''} navbar-collapse`"
      id="navbarSupportedContent"
    >
      <ul class="navbar-nav ml-auto">
        <li class="nav-item active">
          <a class="nav-link" href="/categories">Shop</a>
        </li>

        <li class="nav-item active">
          <a class="nav-link" href="/learn">Learn</a>
        </li>
        <li class="nav-item active">
          <a class="nav-link" href="/blogs">Blog</a>
        </li>
        <li class="nav-item active">
          <a class="nav-link" href="/jobs">Jobs</a>
        </li>
        <li class="nav-item active">
          <a class="nav-link" href="/find-us">About us</a>
        </li>
      </ul>
      <div
        v-if="!(['search'].indexOf($route.name) > -1)"
        class="input_container mr-2"
      >
        <img
          src="@/assets/svg/Ardunic Elements-01.svg"
          id="dots"
          class="dots"
        />
        <input class="searchh" v-model="word" v-on:keyup.enter="search" />
        <img
          @click="search"
          src="@/assets/svg/Ardunic Elements-03.svg"
          id="search-icon"
        />
      </div>
      <button
        @click="navigate('/cart')"
        class="ardunic-cart-btn my-4 my-sm-0 mx-2"
      >
        {{ $store.getters.getTotalPrice || total_price }}
        <span id="chipss">{{ $store.getters.getCounter || cart.length }}</span>
        <img id="cart" src="@/assets/svg/Ardunic Elements-02.svg" alt />
      </button>
      <button
        class="ardunictn red my-4 my-sm-0 mx-2"
        @click="navigate('/login')"
        v-if="!this.$store.getters.loggedIn"
      >
        Login
      </button>
      <button
        style="  background: linear-gradient(to right, #f6893a, #fdbd5d);"
        class="ardunictn  my-4 my-sm-0 mx-2"
        @click="navigate('/profile')"
        v-if="this.$store.getters.loggedIn"
      >
        Profile
      </button>
      <button
        class="ardunictn red my-4 my-sm-0 mx-2"
        @click="logout"
        v-if="this.$store.getters.loggedIn"
      >
        Logout
      </button>
    </div>
  </nav>
</template>

<script>
import Swal from "sweetalert2";
import Router from "../router";
import axios from "axios";
export default {
  data: () => {
    return {
      word: "",
      cart: [],
      total_price: 0,
      isOpen: false,
    };
  },
  created() {
    if (window.localStorage.getItem("token")) {
      axios
        .get("https://api.ardunic.com/v1/cart", {
          headers: {
            access_token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.cart = res.data.data;
          res.data.data.forEach((item) => {
            this.total_price += item.totalPriceAfterDiscounted;
          });
          this.$store.dispatch("addToCardIncrease", {
            qty: this.cart.length,
            price: this.total_price,
          });
        });
    }
  },
  methods: {
    navigate(route) {
      Router.push({ path: route });
      // console.log(this.$store);
    },
    logout() {
      localStorage.removeItem("token");
      // Router.push({path: '/'});
      Swal.fire({
        position: "top-end",
        icon: "success",
        width: "20rem",
        title: "See you later <3",
        showConfirmButton: false,
        timer: 1500,
      });
      setTimeout(() => location.reload(), 1600);
    },
    search() {
      axios
        .get(`https://api.ardunic.com/v1/search?name=${this.word}`)
        .then((res) => {
          this.products = res.data.data.products;
          this.word = this.$route.params.word;
        });
      Router.push({ path: `/search/${this.word}/1` });
    },
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style scoped>
.ardunic-cart-btn {
  width: 120px;
  text-align: left;
  padding: 5px 10px 5px 20px;
  background: linear-gradient(to right, #05cefc, #5659ce);
  color: white;
  border: none;
  border-radius: 25px;
  position: relative;
  font-weight: bold;
  font-size: 1rem;
}

form .nav-search {
  background-color: #dee0e1;
  border-radius: 50px;
  width: 350px;
}

#cart {
  position: absolute;
  width: 50px;
  right: 6px;
  top: -5px;
}

#chipss {
  position: absolute;
  right: 16px;
  top: -18px;
  z-index: 1;
  background: linear-gradient(right, #ff3fbb, #ff8891);
  border-radius: 60%;
  width: 25px;
  text-align: center;
  animation: bounce 2s infinite;
}

.searchh {
  border: none;
  outline: none;
  width: 100%;
  height: 100%;
  background-color: gainsboro;
  border-radius: 20px;
}
#search-icon {
  position: absolute;
  right: 0;
  top: -5px;
  width: 37px;
  margin: 0px 5px;
  cursor: pointer;
}

#dots {
  width: 25px;
  margin: 0px 5px;
  cursor: pointer;
}

.navbar-nav {
  margin-right: 20px;
}

.nav-item {
  margin-right: 20px;
}

.nav-link {
  font-weight: 600;
  font-size: 1.5rem;
  color: black;
}

.logo-container {
  display: block;
  text-align: center;
}

.navbar-brand {
  margin-right: 0;
  font-weight: 700;
  font-size: 40px;
  padding: 0;
}
.logo-p {
  font-size: 16px;
  display: block;
  margin-top: -15px;
}

.input_container {
  position: relative;
  display: flex;
  background-color: gainsboro;
  width: 350px;
  height: 30px;
  border-radius: 20px;
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
}

.nav-item {
  position: relative;
}

.nav-item::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -3px;
  width: 60%;
  height: 1px;
  opacity: 0;
  background-color: #5778f3;
  transform: translate(-50%, 0);
  transition: all 0.3s ease-in-out;
}

.nav-item:hover::after {
  width: 100%;
  opacity: 1;
}
</style>
